// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/css/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles.css */
/* ! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 1rem;
  padding-left: 1rem;
}
@media (min-width: 500px) {
  .container {
    max-width: 500px;
  }
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1199px) {
  .container {
    max-width: 1199px;
  }
}
@media (min-width: 1440px) {
  .container {
    max-width: 1440px;
  }
}
@media (min-width: 1921px) {
  .container {
    max-width: 1921px;
  }
}
#persistent-platform-root :is(.fixed) {
  position: fixed;
}
#persistent-platform-root :is(.absolute) {
  position: absolute;
}
#persistent-platform-root :is(.relative) {
  position: relative;
}
#persistent-platform-root :is(.inset-0) {
  inset: 0px;
}
#persistent-platform-root :is(.-bottom-\\[39px\\]) {
  bottom: -39px;
}
#persistent-platform-root :is(.-right-\\[40\\.35px\\]) {
  right: -40.35px;
}
#persistent-platform-root :is(.-right-\\[41\\.35px\\]) {
  right: -41.35px;
}
#persistent-platform-root :is(.-top-10) {
  top: -2.5rem;
}
#persistent-platform-root :is(.bottom-0) {
  bottom: 0px;
}
#persistent-platform-root :is(.left-\\[-39\\.5px\\]) {
  left: -39.5px;
}
#persistent-platform-root :is(.left-\\[-40\\.5px\\]) {
  left: -40.5px;
}
#persistent-platform-root :is(.top-1\\/2) {
  top: 50%;
}
#persistent-platform-root :is(.z-1) {
  z-index: 1;
}
#persistent-platform-root :is(.z-\\[9999\\]) {
  z-index: 9999;
}
#persistent-platform-root :is(.mx-auto) {
  margin-left: auto;
  margin-right: auto;
}
#persistent-platform-root :is(.\\!mb-10) {
  margin-bottom: 2.5rem !important;
}
#persistent-platform-root :is(.-mt-4) {
  margin-top: -1rem;
}
#persistent-platform-root :is(.-mt-\\[322px\\]) {
  margin-top: -322px;
}
#persistent-platform-root :is(.-mt-\\[400px\\]) {
  margin-top: -400px;
}
#persistent-platform-root :is(.mb-16) {
  margin-bottom: 4rem;
}
#persistent-platform-root :is(.mb-2) {
  margin-bottom: 0.5rem;
}
#persistent-platform-root :is(.mb-3) {
  margin-bottom: 0.75rem;
}
#persistent-platform-root :is(.mb-4) {
  margin-bottom: 1rem;
}
#persistent-platform-root :is(.mb-6) {
  margin-bottom: 1.5rem;
}
#persistent-platform-root :is(.mb-\\[10px\\]) {
  margin-bottom: 10px;
}
#persistent-platform-root :is(.mt-10) {
  margin-top: 2.5rem;
}
#persistent-platform-root :is(.mt-64) {
  margin-top: 16rem;
}
#persistent-platform-root :is(.mt-\\[272px\\]) {
  margin-top: 272px;
}
#persistent-platform-root :is(.mt-\\[96px\\]) {
  margin-top: 96px;
}
#persistent-platform-root :is(.block) {
  display: block;
}
#persistent-platform-root :is(.inline) {
  display: inline;
}
#persistent-platform-root :is(.flex) {
  display: flex;
}
#persistent-platform-root :is(.hidden) {
  display: none;
}
#persistent-platform-root :is(.h-\\[146px\\]) {
  height: 146px;
}
#persistent-platform-root :is(.h-\\[28px\\]) {
  height: 28px;
}
#persistent-platform-root :is(.h-\\[90\\%\\]) {
  height: 90%;
}
#persistent-platform-root :is(.h-full) {
  height: 100%;
}
#persistent-platform-root :is(.max-h-\\[146px\\]) {
  max-height: 146px;
}
#persistent-platform-root :is(.min-h-\\[248px\\]) {
  min-height: 248px;
}
#persistent-platform-root :is(.min-h-\\[360px\\]) {
  min-height: 360px;
}
#persistent-platform-root :is(.w-\\[150\\%\\]) {
  width: 150%;
}
#persistent-platform-root :is(.w-\\[548px\\]) {
  width: 548px;
}
#persistent-platform-root :is(.w-full) {
  width: 100%;
}
#persistent-platform-root :is(.max-w-\\[1248px\\]) {
  max-width: 1248px;
}
#persistent-platform-root :is(.max-w-\\[1258px\\]) {
  max-width: 1258px;
}
#persistent-platform-root :is(.max-w-\\[492px\\]) {
  max-width: 492px;
}
#persistent-platform-root :is(.max-w-\\[596px\\]) {
  max-width: 596px;
}
#persistent-platform-root :is(.flex-1) {
  flex: 1 1;
}
#persistent-platform-root :is(.-translate-y-1\\/2) {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#persistent-platform-root :is(.transform) {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
#persistent-platform-root :is(.animate-shimmer) {
  animation: shimmer 1.8s infinite;
}
#persistent-platform-root :is(.resize) {
  resize: both;
}
#persistent-platform-root :is(.flex-row) {
  flex-direction: row;
}
#persistent-platform-root :is(.flex-col) {
  flex-direction: column;
}
#persistent-platform-root :is(.flex-nowrap) {
  flex-wrap: nowrap;
}
#persistent-platform-root :is(.items-center) {
  align-items: center;
}
#persistent-platform-root :is(.justify-end) {
  justify-content: flex-end;
}
#persistent-platform-root :is(.justify-center) {
  justify-content: center;
}
#persistent-platform-root :is(.justify-between) {
  justify-content: space-between;
}
#persistent-platform-root :is(.gap-x-0) {
  column-gap: 0px;
}
#persistent-platform-root :is(.gap-x-0\\.5) {
  column-gap: 0.125rem;
}
#persistent-platform-root :is(.gap-x-2) {
  column-gap: 0.5rem;
}
#persistent-platform-root :is(.gap-x-3) {
  column-gap: 0.75rem;
}
#persistent-platform-root :is(.gap-x-4) {
  column-gap: 1rem;
}
#persistent-platform-root :is(.gap-x-6) {
  column-gap: 1.5rem;
}
#persistent-platform-root :is(.overflow-auto) {
  overflow: auto;
}
#persistent-platform-root :is(.overflow-hidden) {
  overflow: hidden;
}
#persistent-platform-root :is(.overflow-y-auto) {
  overflow-y: auto;
}
#persistent-platform-root :is(.overflow-x-hidden) {
  overflow-x: hidden;
}
#persistent-platform-root :is(.rounded-2xl) {
  border-radius: 1rem;
}
#persistent-platform-root :is(.rounded-\\[16px\\]) {
  border-radius: 16px;
}
#persistent-platform-root :is(.rounded-md) {
  border-radius: 0.375rem;
}
#persistent-platform-root :is(.rounded-xl) {
  border-radius: 0.75rem;
}
#persistent-platform-root :is(.rounded-l-\\[16px\\]) {
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
}
#persistent-platform-root :is(.rounded-r-\\[16px\\]) {
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
}
#persistent-platform-root :is(.border) {
  border-width: 1px;
}
#persistent-platform-root :is(.border-\\[\\#8B8B8B\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(139 139 139 / var(--tw-border-opacity));
}
#persistent-platform-root :is(.border-\\[\\#B6B6B6\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(182 182 182 / var(--tw-border-opacity));
}
#persistent-platform-root :is(.bg-\\[\\#B6B6B6\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(182 182 182 / var(--tw-bg-opacity));
}
#persistent-platform-root :is(.bg-\\[\\#CBE8E6\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(203 232 230 / var(--tw-bg-opacity));
}
#persistent-platform-root :is(.bg-black\\/50) {
  background-color: rgb(0 0 0 / 0.5);
}
#persistent-platform-root :is(.bg-transparent) {
  background-color: transparent;
}
#persistent-platform-root :is(.bg-white) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
#persistent-platform-root :is(.bg-gradient-to-r) {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
#persistent-platform-root :is(.from-transparent) {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
#persistent-platform-root :is(.via-white\\/60) {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
#persistent-platform-root :is(.to-transparent) {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
#persistent-platform-root :is(.p-3) {
  padding: 0.75rem;
}
#persistent-platform-root :is(.p-4) {
  padding: 1rem;
}
#persistent-platform-root :is(.px-24) {
  padding-left: 6rem;
  padding-right: 6rem;
}
#persistent-platform-root :is(.px-\\[25\\%\\]) {
  padding-left: 25%;
  padding-right: 25%;
}
#persistent-platform-root :is(.pt-16) {
  padding-top: 4rem;
}
#persistent-platform-root :is(.text-center) {
  text-align: center;
}
#persistent-platform-root :is(.text-7xl) {
  font-size: 4.5rem;
  line-height: 1;
}
#persistent-platform-root :is(.text-\\[10px\\]) {
  font-size: 10px;
}
#persistent-platform-root :is(.text-\\[12px\\]) {
  font-size: 12px;
}
#persistent-platform-root :is(.text-\\[14px\\]) {
  font-size: 14px;
}
#persistent-platform-root :is(.text-\\[18px\\]) {
  font-size: 18px;
}
#persistent-platform-root :is(.text-\\[20px\\]) {
  font-size: 20px;
}
#persistent-platform-root :is(.text-\\[24px\\]) {
  font-size: 24px;
}
#persistent-platform-root :is(.text-\\[32px\\]) {
  font-size: 32px;
}
#persistent-platform-root :is(.text-\\[36px\\]) {
  font-size: 36px;
}
#persistent-platform-root :is(.text-\\[48px\\]) {
  font-size: 48px;
}
#persistent-platform-root :is(.text-\\[56px\\]) {
  font-size: 56px;
}
#persistent-platform-root :is(.text-base) {
  font-size: 1rem;
  line-height: 1.5rem;
}
#persistent-platform-root :is(.text-lg) {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
#persistent-platform-root :is(.text-sm) {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
#persistent-platform-root :is(.text-xl) {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
#persistent-platform-root :is(.text-xs) {
  font-size: 0.75rem;
  line-height: 1rem;
}
#persistent-platform-root :is(.font-bold) {
  font-weight: 700;
}
#persistent-platform-root :is(.font-medium) {
  font-weight: 500;
}
#persistent-platform-root :is(.font-normal) {
  font-weight: 400;
}
#persistent-platform-root :is(.font-semibold) {
  font-weight: 600;
}
#persistent-platform-root :is(.capitalize) {
  text-transform: capitalize;
}
#persistent-platform-root :is(.leading-\\[20px\\]) {
  line-height: 20px;
}
#persistent-platform-root :is(.leading-\\[24px\\]) {
  line-height: 24px;
}
#persistent-platform-root :is(.leading-\\[28px\\]) {
  line-height: 28px;
}
#persistent-platform-root :is(.leading-\\[32px\\]) {
  line-height: 32px;
}
#persistent-platform-root :is(.leading-\\[44px\\]) {
  line-height: 44px;
}
#persistent-platform-root :is(.leading-\\[48px\\]) {
  line-height: 48px;
}
#persistent-platform-root :is(.leading-\\[56px\\]) {
  line-height: 56px;
}
#persistent-platform-root :is(.leading-\\[80px\\]) {
  line-height: 80px;
}
#persistent-platform-root :is(.text-\\[\\#006B3F\\]) {
  --tw-text-opacity: 1;
  color: rgb(0 107 63 / var(--tw-text-opacity));
}
#persistent-platform-root :is(.text-\\[\\#026A66\\]) {
  --tw-text-opacity: 1;
  color: rgb(2 106 102 / var(--tw-text-opacity));
}
#persistent-platform-root :is(.text-\\[\\#191919\\]) {
  --tw-text-opacity: 1;
  color: rgb(25 25 25 / var(--tw-text-opacity));
}
#persistent-platform-root :is(.text-\\[\\#8B8B8B\\]) {
  --tw-text-opacity: 1;
  color: rgb(139 139 139 / var(--tw-text-opacity));
}
#persistent-platform-root :is(.text-\\[\\#B6B6B6\\]) {
  --tw-text-opacity: 1;
  color: rgb(182 182 182 / var(--tw-text-opacity));
}
#persistent-platform-root :is(.text-\\[\\#F4F4F4\\]) {
  --tw-text-opacity: 1;
  color: rgb(244 244 244 / var(--tw-text-opacity));
}
#persistent-platform-root :is(.text-black) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
#persistent-platform-root :is(.underline) {
  text-decoration-line: underline;
}
#persistent-platform-root :is(.filter) {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

#persistent-platform-root :is(.hover\\:cursor-not-allowed:hover) {
  cursor: not-allowed;
}

#persistent-platform-root :is(.hover\\:cursor-pointer:hover) {
  cursor: pointer;
}

@media (min-width: 1199px) {
  #persistent-platform-root :is(.lg2\\:-mt-16) {
    margin-top: -4rem;
  }
  #persistent-platform-root :is(.lg2\\:mt-\\[272px\\]) {
    margin-top: 272px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB,iEAA0B;AAA1B;;;CAA0B;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,0BAA0B,EAA1B,MAA0B;AAAA;AAA1B;;EAAA,gBAA0B;AAAA;AAA1B;;;;;;;;CAA0B;AAA1B;;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B,EAA1B,MAA0B;EAA1B,WAA0B,EAA1B,MAA0B;EAA1B,+HAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,wCAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,mBAA0B;AAAA;AAA1B;;;;;CAA0B;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,cAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;AAA1B;EAAA,eAA0B;AAAA;AAA1B;EAAA,WAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,uBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,oBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,aAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,gBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,wBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,YAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,wBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,kBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;AAA1B;EAAA,UAA0B;AAAA;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,gBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,eAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;AAC1B;EAAA,WAAgC;EAAhC,kBAAgC;EAAhC,iBAAgC;EAAhC,mBAAgC;EAAhC;AAAgC;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAChC;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;IAAA;EAA+B;EAA/B;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gEAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;;AAH/B;EAAA;AAMA;;AANA;EAAA;AAMA;;AANA;EAAA;IAAA;EAMA;EANA;IAAA;EAMA;AAAA","sourcesContent":["/* src/styles.css */\n@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n@import 'assets/css/typography';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
